import { createFileRoute } from '@tanstack/react-router';
import { InvoicesPage } from '../../features/billing-docs';

export const Route = createFileRoute('/portal/invoices/')({ component: InvoicesPage });
